//BANNERS
export const GET_BANNERS = "/banners"
export const GET_BANNERS_PUBLIC = "/banner"
export const GET_BANNER_PROFILE = "/banners"
export const ADD_NEW_BANNER = "/banners"
export const UPDATE_BANNER = "/banners"
export const DELETE_BANNER = "/banners"
export const ADD_IMAGE_BANNER = '/banners/upload'